export default {
  computed: {
    $currentUser () {
      return this.$store.state.user.currentUser
    },
    $isLoggedIn () {
      return this.$store.state.user.login
    }
  }
}
